import { openColorsSettings } from "utils/open-colors-settings"
import { useBrandColors } from "sdk/brand/queries"
import { useAddBrandColor } from "sdk/brand/mutations"
import { useCurrentUser } from "hooks/use-current-user"

export function useSavedColors() {
  const { canViewAccountSettings } = useCurrentUser()

  return {
    colors: useBrandColors().data,
    handleColorsEdit: canViewAccountSettings ? openColorsSettings : undefined,
    handleColorAdd: useAddBrandColor()
  }
}
